import { u, styled } from '../../../../shared/theming-sc'

const TableHeadCell = styled.th`
    position: relative;
    font-size: ${u.getFontSize('tn')};
    font-weight: 900;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.82;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: ${u.getColor('greyDark')};
    text-align: left;
    width: 200px;
    height: auto !important;
    padding: 14px 40px 14px 0;
    display: table-cell;
    border-bottom: ${u.getColor('greyLighter')} 1px solid;
    vertical-align: top;

    &:first-child{
        padding-left: 30px
    }

    &.frozen-cell {
      &:first-child{
        width: 160px;
        z-index: 20;
        padding-left: 30px;
        overflow: hidden;

        &::before {
            bottom: 1px;
            position: absolute;
            left: 0;
            right: ${u.getSpacing('small')}px;
            background: white;
            top: 0;
            content: '';
            display: block;
            z-index: 0;
            height: 200%;
        }

        &::after{
            background: linear-gradient(to right, rgba(0, 0, 0, .1) 0%,rgba(255,255,255,0) 66.666%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
            width: 15px;
            height: 200%;
            position: absolute;
            right: ${u.getSpacing('smaller')}px;
            top: 0;
            display: block;
            z-index: 25;
            content: "";
        }
      }
    }
`

const DataItem = styled.span`
   text-overflow:ellipsis;
   overflow-x: ${props => (props.showtitlehelpertext === 'showtitlehelpertext' ? '' : 'hidden')};
   display: block;
   width: 100%;
   position: ${props => (props.count === 0 ? 'relative' : '')};
   z-index: 1;
   cursor: pointer;

    svg {
       position: relative;
       visibility: hidden;

       &.showReactSort {
           visibility: visible;
       }
    }
    &:hover{
        svg {
            visibility: visible
        }
    }
    span {
        &.showReactSort{
            svg {
                visibility: visible
            }
        }
        &.showtitlehelpertext{
            svg {
                visibility: visible;
                top: 0;
            }

        }
        &.tableheaderCheckbox{
            display: table-cell;
            padding-left: ${u.getSpacing('smaller')}px;
        }
   }
`

const TitleHelperTextSpan = styled.span`
   display: table-cell;
`

const SortSpan = styled.span`
    vertical-align: top;
    display: table-cell;
`

export {
  TableHeadCell,
  DataItem,
  SortSpan,
  TitleHelperTextSpan
}
